<template>
  <el-dialog
    top="5vh"
    class="dialog-full-medium"
    width="600px"
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
    append-to-body
    custom-class="set-dialog__body"
  >
    <div class="dialog__body">
      <el-form
        :model="ruleForm"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-width="120px"
        label-position="left"
      >
        <!-- 批量页面 -->
        <el-row :gutter="20" v-if="isBatch">
          <el-col :span="12">
            <data-show label="付款总额度：">
              {{paymentObj.paymentTotalAmount | toFenThousandsAndFloat}}
            </data-show>
          </el-col>
          <el-col :span="12">
            <data-show label="付款总笔数：">
              {{paymentObj.paymentTotalNumber || '0'}}
            </data-show>
          </el-col>
        </el-row>
        <!-- 单个页面 -->
        <div class="content-h" v-else>
          <div class="h-left">
            <data-show label="服务商: ">
              {{paymentObj.payeeBusinessName || '-'}}
            </data-show>
            <div class="num">¥{{paymentObj.payAmount | toFenThousandsAndFloat}}</div>
          </div>
          <div class="h-right">
            <data-show label="供应商: ">
              {{paymentObj.businessName || '-'}}
            </data-show>
            <div>待付金额</div>
          </div>
        </div>

        <!-- 综合/单个(银行/支付宝)发起支付-类型切换 -->
        <el-tabs v-model="activeName" @tab-click="handleTabsClick">
          <!-- 现金确认 -->
          <template v-if="type === 'confirmPay'">
            <el-tab-pane label="附件信息" name="confirmPay" />
          </template>
          <!-- 对公账户情况下 只有线下支付 -->
          <template v-else-if="type === 'onlyOffline'">
            <el-tab-pane label="线下支付" name="offline" />
          </template>
          <template v-else>
            <el-tab-pane label="线上支付" name="online" v-if="type === 'online' || type === 'all'" />
            <el-tab-pane label="线下支付" name="offline" v-if="type === 'offline' || type === 'all'" />
          </template>
        </el-tabs>

        <!-- 线上支付 -->
        <div class="tab-message" v-if="activeName === 'online'">
          <div class="main-cont-item">
            <h2 class="title-text">
              {{isAliPayMode ? '收款账户信息':'目标银行账户信息'}}
            </h2>
            <bank-info :payment-obj="paymentObj" />
          </div>
          <payways-list
            ref="payWaysListRef"
            :paymentInfoNewList="paymentInfoNewList"
            :loading="paymentChannelLoading"
            :paymentObj="paymentObj"
            :payMethodObj="payMethodObj"
            :code.sync="ruleForm.code"
            :channelCode.sync="ruleForm.channelCode"
            @channelCodeChange="channelCodeChange"
            @paymentChannelChange="paymentChannelChange"
          />
        </div>
        <!-- 人工支付 -->
        <div class="tab-message" v-if="activeName === 'offline'">
          <div class="main-cont-item">
            <h2 class="title-text">目标账户信息</h2>
            <bank-info :payment-obj="paymentObj" />
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">出款账户信息</h2>
            <el-form-item prop="bankAccountNo" class="form-item-box">
              <el-row :gutter="20">
                <el-col :span="16">
                  <select-account
                    :bakAcctList="bakAcctList"
                    :bankAccount="ruleForm.bankAccountNo"
                    @change="bankAccountNoChange"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">上传付款凭证</h2>
            <el-form-item prop="imageList" class="form-item-box">
              <upload
                accept=".jpg, .jpeg, .png,.pdf"
                :fileLimit="999"
                path="payment/offline/"
                :file-list="ruleForm.picUrl"
                :uploading.sync="uploading"
                @update="handleUploadUpdate"
                @upload-paste="handleUploadPaste"
              />
            </el-form-item>
          </div>
        </div>
        <!-- 现金确认 -->
        <div class="tab-message" v-if="activeName === 'confirmPay'">
          <div class="main-cont-item">
            <h2 class="title-text">上传付款凭证</h2>
            <el-form-item prop="cashImage" class="form-item-box">
              <upload
                accept=".jpg, .jpeg, .png,.pdf"
                :limit="999"
                path="payment/offline/"
                :file-list="ruleForm.picUrl"
                :uploading.sync="uploading"
                @update="handleUploadUpdate"
                @upload-paste="handleUploadPaste"
              />
            </el-form-item>
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">备注</h2>
            <el-form-item prop="remark" class="form-item-box">
              <el-input
                type="textarea"
                placeholder="请备注说明付款的方式和账户"
                v-model="ruleForm.remark"
                show-word-limit
                :rows="3"
              />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <template v-if="$has('FWS-SFKGL-FKD-FKTJ')">
        <el-button @click="handleClose()" :size="formSize">取消</el-button>
        <el-button
          type="primary"
          :size="formSize"
          @click="submit()"
          :loading="submitLoading"
          :disabled="uploading"
        >
          提交
        </el-button>
      </template>
      <el-button v-else @click="handleClose()" :size="formSize">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { setPaymentPaymentOffline, getBakAcctList } from '@/api/receivables';
import Upload from '@/components/upload';
import operate from '../mixins/operate';
import bankInfo from './bank-info';
import paywaysList from '@/views/components/payways-list';
import SelectAccount from '@/views/components/select-accont/select-account';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /**
     * 类型：
     * all: 综合支付(再次支付),
     * online: 线上支付,
     * offline: 线下支付,
     * onlyOffline 仅为线下付款
     * confirmPay: 确认付款
    */
    type: {
      type: String,
      default: 'all',
    },
    // 是否批量
    isBatch: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: '发起付款',
    },
    paymentNo: {
      type: String,
      default: '',
    },
    paymentObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    activeName() {
      this.$refs.ruleForm.resetFields();
    },
  },
  mixins: [operate],
  components: { Upload, bankInfo, paywaysList, SelectAccount },
  data() {
    const that = this;
    const validatePicUrl = (rule, value, callback) => {
      if (!that.ruleForm.imageList || that.ruleForm.imageList.length === 0) {
        callback(new Error('请上传付款凭证'));
      } else {
        callback();
      }
    };
    return {
      uploading: false,
      activeName: 'online',
      isAliPayMode: true,
      ruleForm: {
        code: '',
        paymentChannelNo: '',
        paymentChannelName: '',
        picUrl: [],
        imageList: [],
        channelCode: '',
        bankAccountNo: '',
        channelNo: '',
        payeeBusinessNo: '',
      },
      rules: {
        code: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' },
        ],
        paymentChannelNo: [
          { required: true, message: '选择不能为空', trigger: 'change' },
        ],
        channelCode: [
          { required: true, message: '选择不能为空', trigger: 'change' },
        ],
        imageList: [
          { validator: validatePicUrl, trigger: 'blur' },
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' },
        ],
        bankAccountNo: [
          { required: true, message: '选择不能为空', trigger: 'change' },
        ],
      },
      bakAcctList: [], // 出款账户
    };
  },
  methods: {
    // tab切换
    handleTabsClick() {
      this.$refs.ruleForm.resetFields();
      if (this.activeName === 'online') {
        this.ruleForm.channelCode = this.paymentInfoNewList.length ? 'ybpay' : ''; // 默认显示易宝数据
        this.$nextTick(() => {
          this.$refs.payWaysListRef.channelCodeChange('ybpay');
        });
      }
    },
    // 图片上传返回
    handleUploadUpdate(images) {
      this.ruleForm.picUrl = (images || []).map((item) => (item));
      this.ruleForm.imageList = JSON.parse(JSON.stringify(this.ruleForm.picUrl));
      this.$refs.ruleForm.validateField('imageList');
    },
    // 图片粘贴返回
    handleUploadPaste(image) {
      this.ruleForm.picUrl.push(image);
      this.ruleForm.imageList = JSON.parse(JSON.stringify(this.ruleForm.picUrl));
      this.$refs.ruleForm.validateField('imageList');
    },
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('update:paymentNo', '');
      if (this.$refs.payWaysListRef) {
        this.$refs.payWaysListRef.clearInterval();
      }
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.isAliPayMode = this.paymentObj.payMode === 'ALIPAY';
        const list = {
          all: 'online',
          online: 'online',
          offline: 'offline',
          onlyOffline: 'offline',
          confirmPay: 'confirmPay',
        };
        this.activeName = (list[this.type] || 'online');
        this.ruleForm = {
          code: '',
          paymentChannelNo: '',
          paymentChannelName: '',
          channelCode: '',
          picUrl: [],
          bankAccountNo: '',
          channelNo: '',
          payeeBusinessNo: '',
        };
        this.bakAcctList = [];

        if (this.activeName === 'online') this.getPaymentPaymentPayMethod(this.paymentNo, 2);
        if (this.type !== 'online') this._getBakAcctList();
        this.$refs.ruleForm.resetFields();
        this.timeStr = 0;
        this.timer = null;
        this.isFlag = false;
      });
    },
    // 提交
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.activeName === 'online') {
            this.handleOnline(2);
            return;
          }
          this.handleOffline();
        }
      });
    },

    // 线下支付
    handleOffline() {
      const { picUrl, remark, bankAccountNo } = this.ruleForm;
      const [receiptTypeItme] = this.bakAcctList.filter((el) => el.bankAccountNo === bankAccountNo);
      const { accountNumber, accountName, bankName, payBankBranchInfo, payBankAccountType } = receiptTypeItme || {};
      const urlList = (picUrl || []).map(((item) => item.fileId));
      const params = {
        paymentNo: this.paymentNo, // 付款单号
        payAmount: this.paymentObj.payAmount, // 付款金额
        pic: urlList?.join(',') || '', // 付款图片
        remark,
        accountNumber: accountNumber || '', // 付款账户
        accountName: accountName || '', // 付款户名
        bankName: bankName || '', // 银行名称
        payBankBranchInfo: payBankBranchInfo || '', // 支行名称
        payBankAccountType: payBankAccountType || '', // 账户类型
      };
      this.submitLoading = true;
      // 付款单列表-发起付款-线下付款
      setPaymentPaymentOffline(params).then(() => {
        this.$message.success('操作成功！');
        this.handleClose();
        this.$emit('success');
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    _getBakAcctList() {
      const obj = {
        BANK_CARD_PAY: '1',
        ALIPAY: '2',
        WECHAT: '3',
      };
      const value = obj[this.paymentObj.payMode];
      getBakAcctList({
        accountCategory: value,
        paymentNo: this.paymentNo,
        principalType: 1,
      }).then((res) => {
        this.bakAcctList = res.data || [];
      });
    },
    bankAccountNoChange(no) {
      this.ruleForm.bankAccountNo = no;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .form-item-box {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .payment-channel {
    margin-bottom: 0 !important;
    .el-radio {
      display: flex;
      line-height: 20px;
      align-items: center;
      .el-radio__label {
        white-space: break-spaces;
      }
    }
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-button {
    min-width: 64px;
    padding: 8px 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .el-dialog {
    min-width: 600px;
    .el-dialog__body {
      overflow-x: hidden;
    }
  }
  .title-text {
    margin-top: 16px;
  }
}
.set-dialog__body {
  .main-cont-item {
    padding-bottom: 16px;
    margin-bottom: 0;
    border: none;
    h2 {
      font-size: 14px;
    }
    &:last-child {
      padding-bottom: 0px;
    }
  }
  .tab-message {
    max-height: 60vh;
    overflow: auto;
    overflow-x: hidden;
  }
  .content-h {
    // display: flex;
    // justify-content: space-between;
    .h-left {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #4d4f51;
        line-height: 20px;
      }
      .num {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff3741;
        line-height: 30px;
      }
    }
    .h-right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c9ccd1;
      line-height: 18px;
    }
  }
}
</style>
